module.exports = __webpack_public_path__ + "img/SaaS.db9e3a76.png";